import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ViewPasswordComponentDef } from '@df/ui/form/view-password.component.def';
@Component({
    selector: 'view-password',
    templateUrl: './view-password.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class ViewPasswordComponent extends ViewPasswordComponentDef {}
